import script from "./EditSalary.vue?vue&type=script&setup=true&lang=js"
export * from "./EditSalary.vue?vue&type=script&setup=true&lang=js"

import "./EditSalary.vue?vue&type=style&index=0&id=546754c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-546754c5"]])

export default __exports__